import React, { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import EventReport from "./EventReport";
// Sample data based on the provided CSV format
const gamesData = [
  {
    team: "top_30_black",
    opponent: "top_30_white",
    event: "pangos_all-south_frosh/soph_camp",
    game: "top_30_black_vs_top_30_white",
    date: "10/6/2024",
    location: "Duncanville TX",
    jerseyNumber: 10,
    playerName: "Zylan Bernard",
    fg: 2,
    fga: 8,
    threesMade: 0,
    threesAttempted: 2,
    ft: 0,
    fta: 0,
    offReb: 1,
    defReb: 1,
    totReb: 2,
    personalFouls: 0,
    totalPoints: 4,
    assists: 1,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes: 16,
    playerID: "10zylan_bernard",
  },
  // Additional rows can be added here
];

const GamesTab = ({ player }) => {
  const navigate = useNavigate();
  const [eventReportOpen, setEventReportOpen] = useState(false);

  const handleBoxScoreClick = () => {
    navigate("/game/CROWMIDW");
  };

  const handleEventReportClick = () => {
    setEventReportOpen(true);
  };

  const handleEventReportClose = () => {
    setEventReportOpen(false);
  };

  return (
    <div className="games-tab">
      <div className="games-header">
        <h2 style={{ display: "inline-block" }}>Pangos All-South Games</h2>
        <span className="get-event-report" onClick={handleEventReportClick}>
          <DownloadIcon sx={{ verticalAlign: "bottom" }} /> Get Event Report
        </span>
      </div>
      <div className="table-container">
        <table className="games-table">
          <thead>
            <tr>
              <th></th>
              <th>Team</th>
              <th>Opponent</th>
              <th>Event</th>
              <th>Game</th>
              <th>Date</th>
              <th>Location</th>
              <th>Jersey Number</th>
              <th>Player</th>
              <th>FG</th>
              <th>FGA</th>
              <th>3PTM</th>
              <th>3PTA</th>
              <th>FT</th>
              <th>FTA</th>
              <th>Off REB</th>
              <th>Def REB</th>
              <th>Tot REB</th>
              <th>PF</th>
              <th>TP</th>
              <th>Assists</th>
              <th>Turnovers</th>
              <th>Blocks</th>
              <th>Steals</th>
              <th>Minutes</th>
            </tr>
          </thead>
          <tbody>
            {gamesData.map((row, index) => (
              <tr key={index}>
                <td>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      width: "100px",
                      borderRadius: "20px",
                      textTransform: "none",
                    }}
                    onClick={handleBoxScoreClick}
                  >
                    View Box Score
                  </Button>
                </td>
                <td>{row.team}</td>
                <td>{row.opponent}</td>
                <td>{row.event}</td>
                <td>{row.game}</td>
                <td>{row.date}</td>
                <td>{row.location}</td>
                <td>{row.jerseyNumber}</td>
                <td>{row.playerName}</td>
                <td>{row.fg}</td>
                <td>{row.fga}</td>
                <td>{row.threesMade}</td>
                <td>{row.threesAttempted}</td>
                <td>{row.ft}</td>
                <td>{row.fta}</td>
                <td>{row.offReb}</td>
                <td>{row.defReb}</td>
                <td>{row.totReb}</td>
                <td>{row.personalFouls}</td>
                <td>{row.totalPoints}</td>
                <td>{row.assists}</td>
                <td>{row.turnovers}</td>
                <td>{row.blocks}</td>
                <td>{row.steals}</td>
                <td>{row.minutes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <h2>Pangos All-South Advanced Stats</h2>
      <div className="table-container">
        <table className="games-table"></table>
      </div>
      <Dialog
        open={eventReportOpen}
        onClose={handleEventReportClose}
        maxWidth="lg"
        fullWidth
      >
        <EventReport player={player} />
      </Dialog>
    </div>
  );
};

export default GamesTab;
